// Keep Add user decisions testable without calling Supabase or sending invitations.
export async function addUserToTeamFlow({
  email,
  userRole,
  teamName,
  teamId,
  redirectUrl,
  findScribeUser,
  findTeamMembership,
  addScribeUserToTeam,
  inviteNewUser,
}) {
  const scribeUser = await findScribeUser(email);
  if (scribeUser) {
    const membership = await findTeamMembership(scribeUser.id, teamId);
    if (membership) return 'already_in_team';
    await addScribeUserToTeam(scribeUser);
    return 'added_to_team';
  }

  try {
    await inviteNewUser({ email, userRole, teamName, teamId, redirectUrl });
  } catch (error) {
    // The server can resolve a concurrent/existing Auth identity to its Scribe
    // profile without returning an Auth user list to the browser.
    const existingUserId = error.response?.data?.userId;
    if (error.response?.data?.code !== 'email_exists' || !existingUserId) throw error;
    const membership = await findTeamMembership(existingUserId, teamId);
    if (membership) return 'already_in_team';
    await addScribeUserToTeam({ id: existingUserId });
    return 'added_to_team';
  }
  return 'invited';
}
